import BaseModel from '@spa/apps/trustup-pro-base-js/models/BaseModel';

export default class WorksiteFileFolder extends BaseModel
{
    
    data() {
        return {
            id: this.id,
            uuid: this.uuid,
            title: this.title
        }
    }

    static getPrefix()
    {
        return 'worksite:worksite-file-folder';
    }

    static getEndpoint(worksite)
    {
        return window.Worksite.endpoints.worksiteFileFolder.setWorksite(worksite);
    }

    getEndpoint()
    {
        return this.constructor.getEndpoint(this.currentCollection.worksite);
    }

    edit(data = {})
    {
        return super.edit({
            ...data,
            ...{
                worksite: this.currentCollection.worksite
            }
        });
    }

    getRoute()
    {
        return {name: 'account.worksite.files.folder', params: {
            account: window.App.$store.state.account.uuid,
            worksite: window.App.$store.state.worksite.uuid,
            folder: this.uuid
        }};
    }

};